/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type clientListComponent_viewer = {
    readonly insightComponentsData: {
        readonly clientList: {
            readonly currency: string | null;
            readonly projectCountTotal: number | null;
            readonly projectHaltedCountTotal: number | null;
            readonly projectPlanningCountTotal: number | null;
            readonly projectRunningCountTotal: number | null;
            readonly projectDoneCountTotal: number | null;
            readonly reportedTotal: number | null;
            readonly forecastMinutesTotal: number | null;
            readonly forecastPointsTotal: number | null;
            readonly remainingMinutesTotal: number | null;
            readonly remainingPointsTotal: number | null;
            readonly budgetTotal: number | null;
            readonly spendTotal: number | null;
            readonly progressTotal: number | null;
            readonly avgRatePrHourRegistered: number | null;
            readonly avgRatePrHourPlanned: number | null;
            readonly avgRatePrHourFromBudget: number | null;
            readonly clients: ReadonlyArray<{
                readonly id: string;
                readonly name: string | null;
                readonly projectCount: number | null;
                readonly projectHaltedCount: number | null;
                readonly projectPlanningCount: number | null;
                readonly projectRunningCount: number | null;
                readonly projectDoneCount: number | null;
                readonly reported: number | null;
                readonly forecastMinutes: number | null;
                readonly forecastPoints: number | null;
                readonly remainingMinutes: number | null;
                readonly remainingPoints: number | null;
                readonly budget: number | null;
                readonly spend: number | null;
                readonly progress: number | null;
                readonly avgRatePrHourRegistered: number | null;
                readonly avgRatePrHourPlanned: number | null;
                readonly avgRatePrHourFromBudget: number | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "clientListComponent_viewer";
};
export type clientListComponent_viewer$data = clientListComponent_viewer;
export type clientListComponent_viewer$key = {
    readonly " $data"?: clientListComponent_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"clientListComponent_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avgRatePrHourRegistered",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avgRatePrHourPlanned",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avgRatePrHourFromBudget",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "clientListComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientList",
          "kind": "LinkedField",
          "name": "clientList",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectCountTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectHaltedCountTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectPlanningCountTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectRunningCountTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectDoneCountTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "reportedTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastMinutesTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastPointsTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingMinutesTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingPointsTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budgetTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "spendTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "progressTotal",
              "storageKey": null
            },
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientListClient",
              "kind": "LinkedField",
              "name": "clients",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectHaltedCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectPlanningCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectRunningCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectDoneCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "reported",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "forecastMinutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "forecastPoints",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "remainingMinutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "remainingPoints",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "budget",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "spend",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "progress",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'cdd3fdc3bb3a03b9ae9d503df35fa7ac';
export default node;
